// removed by extract-text-webpack-plugin
module.exports = {"menutext":"#bfcbd9","menuactivetext":"#409eff","submenuactivetext":"#f4f4f5","menubg":"#304156","menuhover":"#263445","menulightbg":"#fff","menulighthover":"#f0f1f5","submenubg":"#1f2d3d","submenuhover":"#001528","sidebarwidth":"26.667vw","sidebartitle":"#fff","sidebarlighttitle":"#001529","content":"'viewport-units-buggyfill; sidebarwidth: 26.667vw'"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/index.scss
// module id = N9P1
// module chunks = 63